module.exports = __webpack_public_path__ + "static/sport/ruleboximg1.a6e75f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/ruleboximg1.png
// module id = xiPK
// module chunks = 0